import { englishValidationMessages } from './messages';
import { getMaxLengthValidator, getMinLengthValidator } from './rawValidators';
import { getRequiredValidator } from './required';
const maxLength = 30;
const minLength = 2;
export const getNamePatternErrorMsg = (valueName)=>englishValidationMessages.nameCharacters({
        field: valueName
    });
export const makeNameValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ const getNameValidator = function getNameValidator() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.name, required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (value)=>{
            const requiredError = getRequiredValidator(required)(value);
            if (requiredError !== true) {
                return requiredError;
            }
            if (!getMaxLengthValidator(maxLength)(value)) {
                return valueName ? messages.tooLong({
                    field: valueName,
                    max: maxLength
                }) : false;
            }
            if (!getMinLengthValidator(minLength)(value)) {
                return valueName ? messages.tooShort({
                    field: valueName,
                    min: minLength
                }) : false;
            }
            if (!(typeof value === 'string' && value.match(/[=<>]/) == null)) {
                return valueName ? messages.nameCharacters({
                    field: valueName
                }) : false;
            }
            return true;
        };
    };
    /** For react-hook-form library. */ const nameValidation = function nameValidation(valueName) {
        let { required } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                name: getNameValidator(valueName, required)
            },
            dataAttr: {
                'data-validation': 'name'
            }
        };
    };
    return {
        getNameValidator,
        nameValidation
    };
};
export const { getNameValidator, nameValidation } = makeNameValidators(englishValidationMessages);
